
import React from "react";
import { LucideIcon } from "lucide-react";

interface AdminDashboardCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  linkUrl: string;
  linkText: string;
}

export const AdminDashboardCard: React.FC<AdminDashboardCardProps> = ({
  title,
  description,
  icon,
  linkUrl,
  linkText,
}) => {
  return (
    <div className="p-6 bg-[#181D24] border border-[#222A35] rounded-xl hover:border-[#00B6F0] transition-all shadow-lg hover:shadow-[#00B6F0]/10">
      <div className="flex items-center gap-4 mb-4">
        <div className="p-3 bg-[#1e293b] rounded-lg">
          {icon}
        </div>
        <h2 className="text-2xl font-bold text-white">{title}</h2>
      </div>
      <p className="text-gray-400 mb-6">{description}</p>
      <a 
        href={linkUrl} 
        className="inline-block px-6 py-3 bg-gradient-to-r from-[#00B6F0] to-[#43acdc] text-white font-medium rounded-lg hover:shadow-lg hover:shadow-blue-500/20 transition-all"
      >
        {linkText}
      </a>
    </div>
  );
};
